/* eslint no-use-before-define: 0 */  // --> OFF

import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Typography,
  Grid,
  Button, InputAdornment, Menu, Checkbox, ListItemText
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

import SearchIcon from '@mui/icons-material/Search';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import moment from 'moment';

// import { faker } from '@faker-js/faker';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Filter } from 'src/components/widgets/buttons/Filter';

import FilterListIcon from "@mui/icons-material/FilterList"; // Filter icon
import RestartAltIcon from '@material-ui/icons/RestartAlt';
import { TempoStyleSheet } from './stylesheet';
import toast from 'react-hot-toast';


const initialFilterState = {
  organization: {
    name: "Organization",
    data: [], // Empty by default
  },
  project: {
    name: "Project",
    data: [], // Empty by default
  },
  user: {
    name: "User",
    data: [], // Empty by default
  },
};

const Timesheet: React.FC = () => {
  const useStyles = TempoStyleSheet;
  const classes = useStyles();


  const [filtersApplied, setFiltersApplied] = useState(initialFilterState);
  const [isSubmit, setIsSubmit] = React.useState<boolean>(false);


  const [search, setSearch] = useState<string>();
  const [autoRefresh, setAutoRefresh] = useState<number>(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);



  const [day, setDay] = useState("Days");

  const savedData = localStorage.getItem('timeSheetPagePg');
  const initialState = savedData
    ? JSON.parse(savedData)
    : {
      timeSheetOrganization: '',
      timeSheetProject: '',
      timeSheetUser: '',
    };

  const [organization, setOrganization] = useState<string | null>(
    initialState.timeSheetOrganization
  );
  const [project, setProject] = useState<string | null>(initialState.timeSheetProject);
  const [user, setUser] = useState<string | null>(initialState.timeSheetUser);


  const handleDurationChange = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setDay(value);

    const today = moment(); // Get the current date
    let newStartDate = today;
    let newEndDate;

    switch (value) {
      case "Days":
        newStartDate = today.clone().startOf("day");
        newEndDate = today.clone().endOf("day");
        break;
      case "Week":
        newStartDate = today.clone().startOf("week");
        newEndDate = today.clone().endOf("week");
        break;
      case "Month":
        newStartDate = today.clone().startOf("month");
        newEndDate = today.clone().endOf("month");
        break;
      case "Year":
        newStartDate = today.clone().startOf("year");
        newEndDate = today.clone().endOf("year");
        break;
      case "Quarter":
        newStartDate = today.clone().startOf("quarter");
        newEndDate = today.clone().endOf("quarter");
        break;
      default:
        newStartDate = today;
        newEndDate = today;
    }

    setStartDate(newStartDate.toDate());
    setEndDate(newEndDate?.toDate() || null);
  };





  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);

    if (date && day) {
      const selectedDate = moment(date);
      let updatedEndDate;

      switch (day) {
        case "Days":
          updatedEndDate = selectedDate.clone().add(7, "days");
          break;
        case "Week":
          updatedEndDate = selectedDate.clone().endOf("week");
          break;
        case "Month":
          updatedEndDate = selectedDate.clone().endOf("month");
          break;
        case "Year":
          updatedEndDate = selectedDate.clone().endOf("year"); // End of the current year
          break;
        default:
          updatedEndDate = null; // No adjustment for invalid duration
      }

      setEndDate(updatedEndDate?.toDate() || null);
    }
  };


  const handleEndDateChange = (date: Date | null) => {
    if (startDate && date) {
      const startMoment = moment(startDate);
      const endMoment = moment(date);

      if (endMoment.isBefore(startMoment)) {
        toast.error("End Date cannot be earlier than Start Date.");
        return;
      }

      // if (day === "Days" && endMoment.diff(startMoment, "days") > 7) {
      //   toast("End Date cannot exceed 7 days from Start Date.");
      //   return;
      // }

      // if (day === "Week" && !endMoment.isSame(startMoment, "week")) {
      //   toast("End Date must be within the same week.");
      //   return;
      // }

      // if (day === "Month" && !endMoment.isSame(startMoment, "month")) {
      //   toast("End Date must be within the same month.");
      //   return;
      // }

      if (day === "Year" && !endMoment.isSame(startMoment, "year")) {
        toast("End Date must be within the same year.");
        return;
      }

      setEndDate(date);
    } else {
      setEndDate(date);
    }
  };



  const handleChange = (event: SelectChangeEvent) => {
    setDay(event.target.value as string);
  };



  const handleOrganizationChange = (event: any) => {
    const newOrganization = event.target.value;

    setOrganization(newOrganization);


    setFiltersApplied((prevFilters) => ({
      ...prevFilters,
      organization: {
        ...prevFilters.organization,
        data: [newOrganization],
      },
    }));
  };

  const handleProjectChange = (event: any) => {
    const newProject = event.target.value;


    setProject(newProject);


    setFiltersApplied((prevFilters) => ({
      ...prevFilters,
      project: {
        ...prevFilters.project,
        data: [newProject],
      },
    }));
  };

  const handleUserChange = (event: any) => {
    const newUser = event.target.value;
    setUser(newUser);
    setFiltersApplied((prevFilters) => ({
      ...prevFilters,
      user: {
        ...prevFilters.user,
        data: [newUser],
      },
    }));
  };


  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent page reload if Enter key is pressed
    if (event.key === 'Enter') {
      event.preventDefault();
      console.log('Search query:', search);
      // Perform search logic here
    }
  };

  const updateAutocompleteState = (id, newData): any => {
    switch (id) {
      case 'user':
        setUser(newData);
        break;
      case 'project':
        setProject(newData);
        break;
      case 'organization':
        setOrganization(newData);
        break;
      default:
        break;
    }
  };





  const [dateRange, setDateRange] = useState(() => {
    const today = moment();
    return Array.from({ length: 30 }, (_, i) =>
      today.clone().startOf("month").add(i, "days")
    );
  });


  const generateDateRange = () => {
    const start = moment(startDate || moment());
    let range;

    switch (day) {
      case "Days":
        range = Array.from({ length: 7 }, (_, i) => start.clone().add(i, "days"));
        break;
      case "Week":
        range = Array.from({ length: 7 }, (_, i) =>
          start.clone().startOf("week").add(i, "weeks")
        );
        break;
      case "Month":
        range = Array.from({ length: 12 }, (_, i) =>
          start.clone().startOf("year").add(i, "months")
        );
        break;

      case "Year":
        range = [];
        // Loop through each month of the year
        for (let i = 0; i < 12; i++) {
          // Get the start of the month
          const startOfMonth = start.clone().startOf("year").add(i, "months");
          // Add all the days of that month
          const daysInMonth = Array.from(
            { length: startOfMonth.daysInMonth() },
            (_, j) => startOfMonth.clone().add(j, "days")
          );
          range.push(...daysInMonth); // Add all days of the month to the range
        }
        break;
      case "Quarter":
        range = Array.from({ length: 4 }, (_, i) =>
          start.clone().startOf("year").add(i * 3, "months")
        );
        break;

      // case "Quarter":
      //   range = Array.from({ length: 4 }, (_, i) =>
      //     start.clone().startOf("year").add(i * 3, "months")
      //   );
      //   break;
      default:
        range = [];
    }

    return range;
  };




  const generatedDateRange: any = generateDateRange();


  const renderTableHeaders = () =>
    generatedDateRange.map((date, index) => (
      <TableCell
        key={date}
        style={
          day === "Days" && [6, 0].includes(date.day()) ? { backgroundColor: "#f0f0f0" } : {}
        }
      >

        {day === "Days" && (
          <>
            <div>{date.format("DD")}</div>
            <div>{date.format("ddd")}</div>
          </>
        )}

        {day === "Week" && (
          <>
            <div>
              {date.format("MMM DD")} -{" "}
              {date.add(6, "day").format("DD")}
            </div>
            <div>{date.format("YYYY")}</div>
          </>
        )}

        {day === "Month" && (
          <>
            <div>{date.format("MMM")}</div>
            <div>{date.format("YYYY")}</div>
          </>
        )}

        {day === "Quarter" && (
          <>
            <div>Q{Math.ceil((date.month() + 1) / 3)}</div>
            <div>{date.format("YYYY")}</div>
          </>
        )}

      </TableCell>
    ));


  console.log('generatedDateRange', generatedDateRange)

  // const [entries, setEntries] = useState([
  //   {
  //     id: 1,
  //     user: "Robert Fox",
  //     profileImage: "",
  //     loggedHours: "04h 30m",
  //     // days: [
  //     //   4, 4, 0, 0, 4, 4, 4
  //     // ],
  //     days: generatedDateRange.map(() => Math.floor(Math.random() * 5)),
  //   },
  //   {
  //     id: 2,
  //     user: "John Doe",
  //     profileImage: "",
  //     loggedHours: "02h 15m",
  //     days: generatedDateRange.map(() => Math.floor(Math.random() * 5)),
  //     // days: [
  //     //   4, 4, 0, 0, 4, 4, 4
  //     // ],
  //   },

  // ]);


  const [entries, setEntries] = useState([
    {
      id: 1,
      user: "Robert Fox",
      profileImage: "",
      loggedHours: "04h 30m",
      days: generatedDateRange.map((date) =>
        [6, 0].includes(date.day()) ? 0 : Math.floor(Math.random() * 5)
      ),
    },
    {
      id: 2,
      user: "John Doe",
      profileImage: "",
      loggedHours: "02h 15m",
      days: generatedDateRange.map((date) =>
        [6, 0].includes(date.day()) ? 0 : Math.floor(Math.random() * 5)
      ),
    },
  ]);

  const [weekEntries, setWeekEntries] = useState([
    {
      id: 1,
      user: "Robert Fox",
      profileImage: "",
      loggedHours: "04h 30m",
      days: [
        4, 4, 4, 4, 4, 4, 4

      ],
    },
    {
      id: 2,
      user: "John Doe",
      profileImage: "",
      loggedHours: "02h 15m",
      // days: generatedDateRange.map(() => Math.floor(Math.random() * 5)),
      days: [
        4, 4, 4, 4, 4, 4, 4
      ],
    },

  ]);

  const [monthEntries, setMonthEntries] = useState([
    {
      id: 1,
      user: "Robert Fox",
      profileImage: "",
      loggedHours: "04h 30m",
      days: [
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4

      ],
    },
    {
      id: 2,
      user: "John Doe",
      profileImage: "",
      loggedHours: "02h 15m",
      // days: generatedDateRange.map(() => Math.floor(Math.random() * 5)),
      days: [
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4
      ],
    },

  ]);

  const [quaterEntries, setQuaterEntries] = useState([
    {
      id: 1,
      user: "Robert Fox",
      profileImage: "",
      loggedHours: "04h 30m",
      days: [
        4, 4, 4, 4

      ],
    },
    {
      id: 2,
      user: "John Doe",
      profileImage: "",
      loggedHours: "02h 15m",
      // days: generatedDateRange.map(() => Math.floor(Math.random() * 5)),
      days: [
        4, 4, 4, 4
      ],
    },

  ]);




  const handleResetFilters = () => {
    const defaultState = {
      timeSheetOrganization: '',
      timeSheetProject: '',
      timeSheetUser: '',
    };

    // Reset state
    setOrganization('');
    setProject('');
    setUser('');
    setFiltersApplied(initialFilterState);

    // Reset localStorage
    localStorage.setItem('timeSheetPagePg', JSON.stringify(defaultState));
  };



  useEffect(() => {
    const currentMoment = moment();
    if (day === "Week") {

      setStartDate(currentMoment.clone().startOf("week").toDate());
      setEndDate(currentMoment.clone().endOf("week").toDate());
    }
  }, []);





  useEffect(() => {
    const timeSheetData = {
      timeSheetOrganization: organization,
      timeSheetProject: project,
      timeSheetUser: user,
    };
    localStorage.setItem('timeSheetPagePg', JSON.stringify(timeSheetData));
  }, [organization, project, user, filtersApplied]);





  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem('timeSheetPagePg')) || {};
    const initialFilterStatee = {
      organization: {
        name: "Organization",
        data: savedFilters.timeSheetOrganization ? [savedFilters.timeSheetOrganization] : [],
      },
      project: {
        name: "Project",
        data: savedFilters.timeSheetProject ? [savedFilters.timeSheetProject] : [],
      },
      user: {
        name: "User",
        data: savedFilters.timeSheetUser ? [savedFilters.timeSheetUser] : [],
      },
    };

    setFiltersApplied((prevFilters) => {
      // Avoid unnecessary updates if filtersApplied is already correct
      if (JSON.stringify(prevFilters) === JSON.stringify(initialFilterStatee)) {
        return prevFilters;
      }
      return initialFilterStatee;
    });
  }, []);



  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };
  const handleLeftArrowClick = () => {
    console.log("Left Arrow Clicked");
    if (!endDate) {
      toast.error("Select Date");
      return;
    }
    // Move the start and end date based on the selected duration
    const updatedStartDate = moment(startDate);
    const updatedEndDate = moment(endDate);

    switch (day) {
      case "Days":
        setStartDate(updatedStartDate.subtract(1, "days").toDate());
        setEndDate(updatedEndDate.subtract(1, "days").toDate());
        break;
      case "Week":
        setStartDate(updatedStartDate.subtract(1, "week").toDate());
        setEndDate(updatedEndDate.subtract(1, "week").toDate());
        break;
      case "Month":
        setStartDate(updatedStartDate.subtract(1, "month").toDate());
        setEndDate(updatedEndDate.subtract(1, "month").toDate());
        break;
      case "Year":
        setStartDate(updatedStartDate.subtract(1, "year").toDate());
        setEndDate(updatedEndDate.subtract(1, "year").toDate());
        break;
      case "Quarter":
        setStartDate(updatedStartDate.subtract(1, "quarter").toDate());
        setEndDate(updatedEndDate.subtract(1, "quarter").toDate());
        break;
      default:
        break;
    }
  };

  const handleRightArrowClick = () => {
    console.log("Right Arrow Clicked");


    if (!startDate) {
      toast.error("Select Date");
      return;
    }
    // Move the start and end date based on the selected duration
    const updatedStartDate = moment(startDate);
    const updatedEndDate = moment(endDate);

    switch (day) {
      case "Days":
        setStartDate(updatedStartDate.add(1, "days").toDate());
        setEndDate(updatedEndDate.add(1, "days").toDate());
        break;
      case "Week":
        setStartDate(updatedStartDate.add(1, "week").toDate());
        setEndDate(updatedEndDate.add(1, "week").toDate());
        break;
      case "Month":
        setStartDate(updatedStartDate.add(1, "month").toDate());
        setEndDate(updatedEndDate.add(1, "month").toDate());
        break;
      case "Year":
        setStartDate(updatedStartDate.add(1, "year").toDate());
        setEndDate(updatedEndDate.add(1, "year").toDate());
        break;
      case "Quarter":
        setStartDate(updatedStartDate.add(1, "quarter").toDate());
        setEndDate(updatedEndDate.add(1, "quarter").toDate());
        break;
      default:
        break;
    }
  };


  return (
    <Box className={classes.tempoContainer}>
      <Box sx={{ mt: 1 }}>
        <Box className="optionSection ">
          <Box
            className="LeftSection"
          >
            <Box
              component="form"
              // sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
              noValidate
              autoComplete="off"
              className="SearchBox"
            >
              {/* <SearchBar
                onSearch={handleSearch}
                value={search}
                anyState={autoRefresh !== 0}
              /> */}


              <TextField
                className=""
                placeholder="Search"
                value={search}
                onChange={handleSearch}
                onKeyDown={handleKeyDown}
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            {/* <Grid container spacing={2}>
              <Grid item md={6}>
                <TextField
                  value={startDate ? moment(startDate).format("YYYY-MM-DD") : ""}
                  onChange={(e) => handleStartDateChange(moment(e.target.value).toDate())}
                  label="Start Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item md={6}>
                <TextField
                  value={endDate ? moment(endDate).format("YYYY-MM-DD") : ""}
                  onChange={(e) => handleEndDateChange(moment(e.target.value).toDate())}
                  label="End Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />

              </Grid>
            </Grid> */}


            <Grid container md={12}>
              <Grid container spacing={0}>
                <Grid item md={6}>
                  <TextField
                    value={startDate ? moment(startDate).format("YYYY-MM-DD") : ""}
                    onChange={(e) => handleStartDateChange(moment(e.target.value).toDate())}
                    label="Start Date"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" onClick={handleLeftArrowClick} style={{ cursor: "pointer" }}>
                          <ArrowBackIos />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item md={6}>
                  <TextField
                    value={endDate ? moment(endDate).format("YYYY-MM-DD") : ""}
                    onChange={(e) => handleEndDateChange(moment(e.target.value).toDate())}
                    label="End Date"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" onClick={handleRightArrowClick} style={{ cursor: "pointer" }}>
                          <ArrowForwardIos />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>


            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="duration-select-label">Duration</InputLabel>
                <Select
                  labelId="duration-select-label"
                  value={day}
                  onChange={handleDurationChange}
                >
                  <MenuItem value="Days">Days</MenuItem>
                  <MenuItem value="Week">Week</MenuItem>

                  <MenuItem value="Month">Month</MenuItem>
                  <MenuItem value="Quarter">Quarter</MenuItem>

                </Select>
              </FormControl>
            </Box>

            <Box sx={{ minWidth: 120 }} className="filterSec">
              <FormControl fullWidth>
                <InputLabel id="organization-select-label">Organization</InputLabel>
                <Select
                  labelId="organization-select-label"
                  value={organization}
                  onChange={handleOrganizationChange}
                >
                  {/* Placeholder MenuItem */}
                  <MenuItem value="" disabled>
                    Select a Organization
                  </MenuItem>
                  <MenuItem value="Organization A">Organization A</MenuItem>
                  <MenuItem value="Organization B">Organization B</MenuItem>
                  <MenuItem value="Organization C">Organization C</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ minWidth: 120 }} className="filterSec">
              <FormControl fullWidth>
                <InputLabel id="project-select-label">Project</InputLabel>
                <Select
                  labelId="project-select-label"
                  value={project}
                  onChange={handleProjectChange}
                >
                  {/* Placeholder MenuItem */}
                  <MenuItem value="" disabled>
                    Select a Project
                  </MenuItem>
                  <MenuItem value="Project x">Project X</MenuItem>
                  <MenuItem value="Project y">Project Y</MenuItem>
                  <MenuItem value="Project z">Project Z</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ minWidth: 120 }} className="filterSec">
              <FormControl fullWidth>
                <InputLabel id="user-select-label">User</InputLabel>
                <Select
                  labelId="user-select-label"
                  value={user}
                  onChange={handleUserChange}
                >
                  {/* Placeholder MenuItem */}
                  <MenuItem value="" disabled>
                    Select a User
                  </MenuItem>
                  <MenuItem value="user 1">User 1</MenuItem>
                  <MenuItem value="user 2">User 2</MenuItem>
                  <MenuItem value="user 3">User 3</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box>
              <Button
                className="btnReset"
                variant="contained"
                color="secondary"
                onClick={handleResetFilters}
                title="Reset to defaults"
                sx={{
                  minWidth: '50px',
                  ml: 1,
                }}>
                <RestartAltIcon />
              </Button>

            </Box>
          </Box>
        </Box>
      </Box>


      <Box className="filterViewBox" sx={{ mrginBottom: '10px' }}>
        {Object.values(filtersApplied).some((val) => val !== null) && (
          <Box marginTop="5px" marginLeft="-5px">
            {/* Filters: */}
            {Object.keys(filtersApplied).map((keyName) =>
              filtersApplied[keyName] !== null ? (
                <Filter
                  filtersApplied={{ ...filtersApplied }}
                  key={keyName}
                  id={keyName}
                  setFiltersApplied={setFiltersApplied}
                  updateAutocompleteState={updateAutocompleteState}
                  setIsSubmit={setIsSubmit}
                />
              ) : (
                ''
              )
            )}
          </Box>
        )}
      </Box>

      <TableContainer component={Paper} className={classes.tempoContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Users
                <IconButton onClick={handleClick}>
                  <FilterListIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  className="menuFilterItem"
                >
                  <div style={{ padding: "10px" }}>
                    <Typography className="menuFilterHeader" sx={{
                      color: '#8492A6',
                      fontSize: '10px',
                      minWidth: '70px',
                      textAlign: 'left',
                      fontWeight: 600,
                      lineHeight: '16px',
                      letterSpacing: '0.06em',
                      textUnderlinePosition: 'from-font',
                      textDecorationSkipInk: 'none',
                      paddingBottom: '10px',
                      borderBottom: 'solid 1px #8492A6'
                    }}>Filter</Typography>
                    <MenuItem sx={{
                      paddingLeft: '0px !important',
                      paddingTop: '10px !important',

                    }}
                      onClick={() => handleToggle("Option A")}>
                      <Checkbox checked={selectedOptions.includes("Option A")} />
                      <ListItemText primary="Option A" />
                    </MenuItem>
                    <MenuItem
                      sx={{
                        paddingLeft: '0px !important'
                      }}
                      onClick={() => handleToggle("Option B")}>
                      <Checkbox checked={selectedOptions.includes("Option B")} />
                      <ListItemText primary="Option B" />
                    </MenuItem>
                    <MenuItem
                      sx={{
                        paddingLeft: '0px !important'
                      }}
                      onClick={() => handleToggle("Option C")}>
                      <Checkbox checked={selectedOptions.includes("Option C")} />
                      <ListItemText primary="Option C" />
                    </MenuItem>
                  </div>
                </Menu>
              </TableCell>
              <TableCell>Logged</TableCell>
              {renderTableHeaders()}
            </TableRow>
          </TableHead>
          <TableBody>
            {day === "Days" && (
              entries.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>
                    <div className="profileNameImg">
                      <img
                        src={entry.profileImage || "https://via.placeholder.com/40"}
                        alt={entry.user}
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: "0.5rem",
                        }}
                      />
                      {entry.user}
                    </div>
                  </TableCell>
                  <TableCell>{entry.loggedHours}</TableCell>
                  {entry.days.map((hours, index) => (
                    <TableCell
                      key={hours}
                      // style={
                      //   hours === 0
                      //     ? { backgroundColor: "#f0f0f0" }
                      //     : {}
                      // }
                      style={
                        // eslint-disable-next-line 
                        day === "Days" && [6, 0].includes(generatedDateRange[index].day()) // Check for Saturday (6) or Sunday (0)
                          ? { backgroundColor: "#f0f0f0" }
                          : hours === 0
                            ? {}
                            : {}
                      }
                    >
                      {hours > 0 ? `${hours}h` : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}

            {day === "Week" && (
              weekEntries.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>
                    <div className="profileNameImg">
                      <img
                        src={entry.profileImage || "https://via.placeholder.com/40"}
                        alt={entry.user}
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: "0.5rem",
                        }}
                      />
                      {entry.user}
                    </div>
                  </TableCell>
                  <TableCell>{entry.loggedHours}</TableCell>
                  {entry.days.map((hours, index) => (
                    <TableCell
                      key={hours}

                    >
                      {hours > 0 ? `${hours}h` : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}

            {day === "Month" && (
              monthEntries.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>
                    <div className="profileNameImg">
                      <img
                        src={entry.profileImage || "https://via.placeholder.com/40"}
                        alt={entry.user}
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: "0.5rem",
                        }}
                      />
                      {entry.user}
                    </div>
                  </TableCell>
                  <TableCell>{entry.loggedHours}</TableCell>
                  {entry.days.map((hours, index) => (
                    <TableCell
                      key={hours}

                    >
                      {hours > 0 ? `${hours}h` : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}

            {day === "Quarter" && (
              quaterEntries.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>
                    <div className="profileNameImg">
                      <img
                        src={entry.profileImage || "https://via.placeholder.com/40"}
                        alt={entry.user}
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          marginRight: "0.5rem",
                        }}
                      />
                      {entry.user}
                    </div>
                  </TableCell>
                  <TableCell>{entry.loggedHours}</TableCell>
                  {entry.days.map((hours, index) => (
                    <TableCell
                      key={hours}

                    >
                      {hours > 0 ? `${hours}h` : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}

          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Timesheet;
